import React from "react";

import { HeaderDesktopContent } from "@faire/retailer/components/Header/desktop/HeaderDesktopContent";
import { NavigationLinksBar } from "@faire/retailer/components/Header/desktop/NavigationLinksBar/NavigationLinksBar";
import { HeaderContainer } from "@faire/retailer/components/Header/styled";
import { useIsSettingSemSimplifiedLpEnabled } from "@faire/retailer/settings/useSettingSemSimplifiedLp";

export const HeaderDesktop = ({ className }: { className?: string }) => {
  const isSettingSemSimplifiedLpEnabled = useIsSettingSemSimplifiedLpEnabled();

  return (
    <HeaderContainer className={className}>
      <HeaderDesktopContent />
      {isSettingSemSimplifiedLpEnabled ? null : <NavigationLinksBar />}
    </HeaderContainer>
  );
};
